import { render, staticRenderFns } from "./TestResultLine.vue?vue&type=template&id=489e1345&scoped=true&"
import script from "./TestResultLine.vue?vue&type=script&lang=js&"
export * from "./TestResultLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e1345",
  null
  
)

export default component.exports